export default `
<!DOCTYPE html>
<html>
  <head></head>
  <link
    href=${`//${window.location.host}/stylesheets/live-preview/live-preview.css`}
    rel="stylesheet"
  >
  <link href="https://fonts.googleapis.com/css2?family=Lato&family=Montserrat&family=Nunito+Sans&family=Open+Sans&family=Oswald&family=Raleway&family=Roboto:wght@400;700&family=Source+Sans+Pro&family=Crimson+Text:wght@600&family=Poppins:wght@600&family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet">
  <body class="website-view a">
    <div id="mount-here">
    </div>
  </body>
</html>
`;
